/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ErrorStateClearedPayload
 */
export interface ErrorStateClearedPayload {
    [key: string]: any | any;
    /**
     * 
     */
    type: ErrorStateClearedPayloadTypeEnum;
    /**
     * 
     */
    how: string;
    /**
     * 
     */
    reason?: string | null;
    /**
     * 
     */
    captureId?: string | null;
}


/**
 * @export
 */
export const ErrorStateClearedPayloadTypeEnum = {
    ErrorStateCleared: 'error_state_cleared',
} as const;
export type ErrorStateClearedPayloadTypeEnum = typeof ErrorStateClearedPayloadTypeEnum[keyof typeof ErrorStateClearedPayloadTypeEnum];


/**
 * Check if a given object implements the ErrorStateClearedPayload interface.
 */
export function instanceOfErrorStateClearedPayload(value: object): value is ErrorStateClearedPayload {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (value['type'] !== 'error_state_cleared') return false;
    
    if (!('how' in value) || value['how'] === undefined) return false;
    return true;
}

export function ErrorStateClearedPayloadFromJSON(json: any): ErrorStateClearedPayload {
    return ErrorStateClearedPayloadFromJSONTyped(json, false);
}

export function ErrorStateClearedPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): ErrorStateClearedPayload {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'type': json['type'],
        'how': json['how'],
        'reason': json['reason'] === undefined ? undefined : json['reason'] === null ? null : json['reason'],
        'captureId': json['capture_id'] === undefined ? undefined : json['capture_id'] === null ? null : json['capture_id'],
    };
}

export function ErrorStateClearedPayloadToJSON(json: any): ErrorStateClearedPayload {
    return ErrorStateClearedPayloadToJSONTyped(json, false);
}

export function ErrorStateClearedPayloadToJSONTyped(value?: ErrorStateClearedPayload | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'type': value['type'],
        'how': value['how'],
        'reason': value['reason'],
        'capture_id': value['captureId'],
    };
}

